import { forwardRef } from 'react';
import { cn } from '../../utils/cn';

// Valores arbitrarios (no las utilidades p-3/p-5) porque bootstrap.min.css
// redefine .p-0..5 con !important y les gana a las utilidades Tailwind
// homónimas (p-5 → 3rem en vez de 1.25rem, inflando el padding de la Card).
// Las clases con valor arbitrario tienen otro nombre y no colisionan.
const paddingStyles = {
  none: '',
  sm: 'p-[0.75rem]',
  md: 'p-[1.25rem]',
  lg: 'p-7',
};

export const Card = forwardRef(({ padding = 'md', className, ...rest }, ref) => (
  <div
    ref={ref}
    className={cn(
      'bg-bg border border-border rounded-xl shadow-card',
      paddingStyles[padding],
      className,
    )}
    {...rest}
  />
));
Card.displayName = 'Card';

export function CardHeader({ className, ...rest }) {
  return <div {...rest} className={cn('mb-4 flex items-start justify-between gap-3', className)} />;
}

export function CardTitle({ className, ...rest }) {
  return <h3 {...rest} className={cn('text-base font-semibold text-fg', className)} />;
}

export function CardDescription({ className, ...rest }) {
  return <p {...rest} className={cn('text-sm text-fg-muted', className)} />;
}

export function CardFooter({ className, ...rest }) {
  return (
    <div
      {...rest}
      className={cn('mt-4 pt-4 border-t border-border flex items-center justify-end gap-2', className)}
    />
  );
}
